<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
          xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-back="false" :has-nav="false">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="flex a-center bg-white p-h-40 p-t-40">
        <img alt="" class="flex-s-0"
             src="../../../assets/common/ic_default_img.png"
             style="width: 94px;height: 94px"
             v-if="!proImgUrl">
        <img :src="proImgUrl" alt=""
             class="flex-s-0"
             style="width: 94px;height: 94px"
             v-if="proImgUrl">
        <div class="flex-1 flex-column j-center p-l-20" style="align-items: flex-start">
          <div class="fs-20 color-33 bold">{{ proName }}</div>
        </div>
        <img :src="proQrcode" @click="showQrCode=true" alt="" class="flex-s-0"
             style="width: 94px;height: 94px"
             v-if="proQrcode">
      </div>

      <div class="m-auto m-b-5 p-h-40 p-t-20"
           style="min-height: calc(100% - 5px);background-color: white">
        <div class="p-v-20">
          <Table :columns="columns" :data="getBarData" class="tablePtye">
            <template v-slot:dIcon="{row,index}">
              <div class="flex a-center j-center">
                <div @click="onPicChooseClick(row)" style="width: 40px;height: 40px">
                  <img src="../../../assets/common/ic_default_img.png"
                       style="width: 40px;height: 40px;cursor: pointer"
                       v-if="!row.iconUrl">
                  <img :src="row.iconUrl" style="width: 40px;height: 40px;cursor: pointer"
                       v-if="row.iconUrl">
                </div>
              </div>
            </template>
            <template v-slot:sIcon="{row,index}">
              <div class="flex a-center j-center">
                <div @click="onPicChooseClick(row)" style="width: 40px;height: 40px">
                  <img src="../../../assets/common/ic_default_img.png"
                       style="width: 40px;height: 40px;cursor: pointer" v-if="!row.iconSelUrl">
                  <img :src="row.iconSelUrl" style="width: 40px;height: 40px;cursor: pointer"
                       v-if="row.iconSelUrl">
                </div>
              </div>
            </template>
            <template v-slot:copy="{row,index}">
              <div class="flex a-center">
                <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                     v-clipboard:copy="row.linkurl"
                     v-clipboard:error="onError"
                     v-clipboard:success="copy"/>

              </div>
            </template>
            <template v-slot:status="{row,index}">
              <div class="flex a-center">
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #EEFFEF;color: #4CAF50;border-radius: 11px;"
                     v-if="row.status === 1">
                  已发布
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: red;border-radius: 11px;"
                     v-if="row.status !== 1">
                  未发布
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: #FF6D00;border-radius: 11px;"
                     v-if="row.isDefault === 1">
                  首页
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: #FF6D00;border-radius: 11px;"
                     v-if="row.isRelation === 1">
                  已关联
                </div>
                <!--<div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"-->
                <!--style="background-color: #FFF3EB;color: #FF6D00;border-radius: 11px;" v-if="row.type === 9">-->
                <!--官网-->
                <!--</div>-->
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2 m-r-10"
                     style="background-color: #FFF3EB;color: #FF6D00;border-radius: 11px;"
                     v-if="row.type === 7">
                  商品
                </div>
              </div>
            </template>
            <template v-slot:operation="{row,index}">
              <div class="flex a-center fs-12">
                <span @click="onProductRenovationClick(row)" class="m-r-20"
                      style="color:#3B80FF;cursor: pointer"
                      v-if="row.type===7">装修页面</span>
                <span :style="{color:getUnableRelationStatus(row,index)}"
                      @click="onPageRenovationClick(row)" class="m-r-20"
                      style="cursor: pointer"
                      v-else>装修页面</span>
                <span
                  :style="{color:getUnableRelationStatus(row,index)}" @click="onStyleSettingClick(row)"
                  class="m-r-20"
                  style="cursor: pointer;color: #3B80FF">页面设置</span>
                <span :style="{color:getUnableRelationStatus(row,index)}"
                      @click="onShareSettingClick(row,index)"
                      class="m-r-20"
                      style="color:#3B80FF;cursor: pointer">分享设置</span>
                <span :style="{color:getUnableStatus(row,index)}" @click="setDefaultPage(row,index)"
                      class="m-r-20"
                      style="color:#3B80FF;cursor: pointer">首页设置</span>
                <span @click="onRenameClick(row)" class="m-r-20"
                      style="color:#3B80FF;cursor: pointer">重设名称</span>
                <span
                  :style="{color:getUnableStatus(row,index),visibility:row.type !== 7?'visible':'hidden'}"
                  @click="onRelationEdit(row)"
                  class="m-r-15"
                  style="color:#3B80FF;cursor: pointer;">关联页面</span>
                <span :style="{color:getStatus(row),visibility:row.type !== 7?'visible':'hidden'}"
                      @click="changeStatus(row,index)"
                      class="m-r-20"
                      style="cursor: pointer;">{{ row.status === 1 ? '停用' : '发布' }}</span>
                <span :style="{color:getUpItemColor(index)}" @click="moveUp(row,index)"
                      class="m-r-20" style="cursor: pointer"
                      v-if="row.type !== 10">上移</span>
                <span :style="{color:getDownItemColor(index)}" @click="moveDown(row,index)"
                      style="color:#3B80FF;cursor: pointer"
                      v-if="row.type !== 10">下移</span>
              </div>
            </template>
          </Table>
        </div>
      </div>
    </div>

    <!--重置名称弹框-->
    <Modal :closable="false" class="modal-setting" title=" " v-model="renameModal.show"
           width="400px">
      <p class="text-center" slot="header">
        <span>重置名称</span>
      </p>
      <div>
        <div class="w-full">
          <Input :maxlength="5" class="m-b-10" maxlength="5" show-word-limit style="width: 320px"
                 v-model="renameModal.name"/>
        </div>
        <div class="w-full">
          <div class="m-t-15 flex a-center fs-16 bold">
            <img class="w-20 h-20" src="../../../assets/common/ic_zujian.png">
            <div class="m-l-10" style="color:#007AFF">菜单字体</div>
          </div>
          <div class="flex a-center m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">选前颜色：</div>
              <div class="border m-l-10 text-center"
                   style="width: 100px;height: 30px;line-height: 30px">
                {{ renameModal.nameColor }}
              </div>
              <ColorPicker class="m-l-10" recommend
                           v-model="renameModal.nameColor"/>
            </div>
          </div>
          <div class="flex a-center m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">选后颜色：</div>
              <div class="border m-l-10 text-center"
                   style="width: 100px;height: 30px;line-height: 30px">
                {{ renameModal.nameSelectedColor }}
              </div>
              <ColorPicker class="m-l-10" recommend
                           v-model="renameModal.nameSelectedColor"/>
            </div>
          </div>
          <div class="flex a-center text-left m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">字号设置：</div>
              <RadioGroup v-model="renameModal.fontSize">
                <Radio :label="24" class="m-l-10 fs-14">小号</Radio>
                <Radio :label="28" class="m-l-10 fs-14">中号</Radio>
                <Radio :label="32" class="m-l-10 fs-14">大号</Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="flex a-center text-left m-l-20 m-t-10">
            <div class="text-left m-h-10  fs-14 flex a-center">
              <div class="flex-s-0">菜单图标：</div>
            </div>
            <RadioGroup v-model="renameModal.isShowIcon">
              <Radio :label="0" class="fs-14">显示</Radio>
              <Radio :label="1" class="m-l-10 fs-14">隐藏</Radio>
              <Radio :label="2" class="m-l-10 fs-14">凸起</Radio>
            </RadioGroup>
          </div>
        </div>
      </div>
      <div class="w-full flex j-center" slot="footer">
        <Button @click="renameModalCancel">取消</Button>
        <Button @click="renameModalOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
    </Modal>

    <!--风格装修-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose" class="modals"
           class-name="vertical-center-modal" footer-hide v-model="showStyleSet" width="680">
      <style-page-setting-widget :editData='editStyleData' @cancel="showStyleSet=false"
                                 @config="onStylePageOK ">
      </style-page-setting-widget>
    </Modal>

    <!--    分享设置弹框-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose" class="modals"
           class-name="vertical-center-modal" footer-hide v-model="shareModal" width="550">
      <share-page-setting-widget :editData="editShareData" @cancel="shareModal=false"
                                 @config="onShareConfigOK"></share-page-setting-widget>
    </Modal>

    <Modal :closable="false" :mask-closable="false" class="modal-setting modal-setting2" footer-hide
           v-model="showPicChoose" width="380">
      <pic-choose-widget :editPicData="editPicData" @cancel="showPicChoose=false"
                         @ok="onIconOKClick"></pic-choose-widget>
    </Modal>

    <!--企业码下载-->
    <Modal
      class-name="vertical-center-modal"
      footer-hide
      v-model="showQrCode"
      width="550">
      <div class="flex-row" style="border: 1px solid #D1D2D3;  margin: 20px;">
        <div class="flex-column" style="width:90%;flex-shrink: 0;">
          <p class="modal-content-title fz-18 color-33 margin-top-20" style="word-break: break-all">
            商品名称：<span>{{ proName }}</span>&nbsp;&nbsp;
          </p>
          <img :src="proQrcode" alt="" class=" margin-top-20"
               style="width: 180px; height: 180px;">
          <div
            class="flex-row m-t-20"
            style="margin-bottom: 30px;width: 143px;height:33px ;border-radius: 3px;border:1px solid #67B3FF;background-color:#E6F1FC;cursor: pointer">
            <img alt="" src="../../../assets/common/ic_xiazai@2x.png"
                 style="width:15px;height: 14px; ">
            <div @click="onQrcodeDownload" style="color:#1989FA;font-size: 14px;margin-left: 5px">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <!-- 关联页面设置-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onRelationModalClose"
           class="modals"
           class-name="vertical-center-modal" footer-hide v-model="showRelation" width="550">
      <relation-page-url :editData="relationEditInfo" @cancel="showRelation=false"
                         @config="onRelationSetOK"></relation-page-url>
    </Modal>

  </base-page-component>
</template>

<script>
import BasePageComponent from '../../../components/common/BasePageComponent'
import {mapActions} from 'vuex'
import StylePageSettingWidget from '../boot/component/StylePageSettingWidget'
import {parseUrl} from '../../../utils/UrlFormat'
import PicChooseWidget from '../boot/component/PicChooseWidget'
import {handleSimpleDownload} from '../../../utils/filedown'
import SharePageSettingWidget from '../boot/component/SharePageSettingWidget'
import RelationPageUrl from './component/RelationPageUrl'

export default {
  name: 'ProductPage',
  components: {
    RelationPageUrl,
    SharePageSettingWidget,
    PicChooseWidget,
    StylePageSettingWidget,
    BasePageComponent
  },
  data () {
    return {
      proId: 0,
      proName: '',
      proImgUrl: '',
      proQrcode: '',
      showStyleSet: false,                      //风格设置
      showQrCode: false,                        //显示企业码
      shareModal: false,                        //编辑页面分享
      renameModal: {                            //导航重命名
        show: false,
        title: '重置名称',
        name: '',
        nameColor: '',
        nameSelectedColor: '',
        fontSize: 24,
        row: {},
        isShowIcon: 0
      },
      columns: [
        {
          title: '页面名称',
          key: 'name',
          width: 100,
          align: 'left',
        }, {
          title: '选前图标',
          width: 80,
          align: 'center',
          slot: 'dIcon'
        }, {
          title: '选中图标',
          width: 80,
          align: 'center',
          slot: 'sIcon'
        }, {
          title: '更新时间',
          key: 'updatetime',
          align: 'center',
          width: 170
        }, {
          title: '状态',
          slot: 'status',
          align: 'left',
          minWidth: 200
          // }, {
          //   title: '导航链接',
          //   align: 'left',
          //   tooltip: true,
          //   minWidth: 200,
          //   key: 'linkurl'
          // }, {
          //   title: '复制',
          //   slot: 'copy',
          //   width: 70,
          //   align: 'left'
        }, {
          title: '操作',
          slot: 'operation',
          align: 'left',
          width: 530
        }
      ],
      showPicChoose: false,                //选择图标
      selectData: null,
      editPicData: {
        iconSelUrl: '',
        iconUrl: ''
      },
      editShareData: {
        editPageId: 0,
        shareCover: '',
        shareTitle: '',
        showShareBtn: 1,
        extension: this.getEmptyPageExtension(),
      },
      editStyleData: {
        editPageId: 0,
        pageName: '',
        customColor: '#F8F8F9',
        textColor: '#333333',
        titleBgColor: 'white',
        logoWidth: 0,
        logoHeight: 0,
        bgPicWidth: 0,
        bgPicHeight: 0,

        showTitle: 0,
        logo: '',
        bgPic: '',
        buttonUrl: '',
        extension: this.getEmptyPageExtension(),
      },
      buttombarData: [],
      showRelation: false,             //显示关联设置
      relationEditInfo: {
        hasdecorateMode: 1,
        url: ''
      },
      click2ShowRelationEdit: null,
    }
  },
  computed: {
    getBarData () {
      return this.buttombarData.map(res => {
        let jumpUrl = res.sourceLink ? res.sourceLink.link || '' : ''
        let pageId = 0
        if (jumpUrl) {
          let objurl = parseUrl(jumpUrl)
          pageId = parseInt(objurl.id)
        }
        let linkurl = res.link ? res.link.link || '' : ''
        let page = res.page
        let style = JSON.parse(res.style)
        return {
          id: res.id || 0,
          pageId: pageId,
          name: res.name || '',
          iconUrl: res.icon || '',
          iconSelUrl: res.selectedIcon || '',
          iconId: res.iconId || 0,
          selectedIconId: res.selectedIconId || 0,
          isDefault: res.isHome || 0,
          type: res.type,
          jumpUrl: jumpUrl || '',
          sourceLink: res.sourceLink?res.sourceLink.link:'' || '',
          linkurl: linkurl || '',
          relationLink: res.relationLink,
          isRelation: res.isRelation,
          updatetime: res.updateTime || '',
          status: res.isEnable || 0,
          nameColor: style ? style.nameColor || '#000000' : '#000000',
          nameSelectedColor: style ? style.nameSelectedColor || '#FF720B' : '#FF720B',
          fontSize: style ? style.fontSize || 24 : 24,
          isShowIcon: style ? style.showIcon || 0 : 0,
          sort: res.sort,
          page: res.page,
          share: {
            shareTitle: page ? page.shareTitle || '' : '',
            shareCover: page ? page.shareCover || '' : ''
          },
        }
      })
    },
    getEntname () {
      return this.$store.state.company.entName || ''
    },
    getEntLogo () {
      return this.$store.state.company.entLogo || require('../../../assets/common/icon_logo.png')
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.init()
  },
  methods: {
    init () {
      let proId = this.$route.query.proId
      if (proId) {
        this.proId = proId
      }
      this.onGetGoodsDetail()
    },
    getUnableStatus (row, index) {
      if (row.type !== 5 && row.type !== 10) {
        return '#3B80FF'
      } else {
        return '#BBBBBB'
      }
    },
    getUnableRelationStatus (row, index) {
      if (row.type !== 5 && row.type !== 10 && row.isRelation !== 1) {
        return '#3B80FF'
      } else {
        return '#BBBBBB'
      }
    },
    getStatus (row) {
      if (row.status === 1) {
        return 'red'
      } else {
        return 'green'
      }
    },
    onProductRenovationClick (row) {
      const {href} = this.$router.resolve({
        path: '/goodsdetail',
        query: {
          proId: this.proId,
          tagTitle: this.proName + '装修'
        }
      })
      this.$router.push(href)
    },
    onPageRenovationClick (row) {
      if ( row.isRelation){
        this.$Message.info("关联页面已设置,请去关联页面设置")
        return
      }
      var from = 'HomePage'
      if (row.type === 5 || row.type === 10 ) {
        // from = 'Mine'
        return
      }
      const {href} = this.$router.resolve({
        path: '/renovation',
        query: {
          id: row.pageId,
          title: row.name,
          from: from,
          tagTitle: row.name + '装修'
        }
      })
      // window.open(href, 'page' + row.id)
      this.$router.push(href)
    },
    onShareSettingClick (row, index) {                     //点击分享设置
      if ( row.isRelation){
        this.$Message.info("关联页面已设置,请去关联页面设置")
        return
      }
      if (row.type === 10) {
        return
      }
      this.editShareData = {
        editPageId: row.pageId,
        shareCover: row.share.shareCover || '',
        shareTitle: row.share.shareTitle || '',
        showShareBtn: row.page.extension ? JSON.parse(row.page.extension).showShareBtn : 1 || 1,
        extension: {
          ...this.getEmptyPageExtension(),
          ...row.page.extension ? JSON.parse(row.page.extension) : null
        }
      }
      this.shareModal = true
    },
    onShareConfigOK () {
      this.onGetGoodsDetail()
      this.shareModal = false
    },
    onRenameClick (row) {                         //重置名称
      this.renameModal = {
        show: true,
        name: row.name,
        nameColor: row.nameColor || '#000000',
        nameSelectedColor: row.nameSelectedColor || '#FF720B',
        fontSize: row.fontSize || 24,
        isShowIcon: row.isShowIcon,
        row: row,
      }
    },
    onStylePageOK () {
      this.onGetGoodsDetail()
      this.showStyleSet = false
    },
    renameModalCancel () {                        //重置名称 确认
      this.renameModal.show = false
    },
    renameModalOk () {                            ////重置名称 取消
      if (!this.renameModal.name) {
        this.$Message.info('名称不能为空')
        return
      }
      let style = JSON.stringify({
        nameColor: this.renameModal.nameColor || '#000000',
        nameSelectedColor: this.renameModal.nameSelectedColor || '#FF720B',
        circulSelectedColor: 'white',
        hasCircularBg: 0,
        showText: 1,
        showIcon: this.renameModal.isShowIcon,
        fontSize: this.renameModal.fontSize,
        isMineHidden: 0
      })
      let params = {
        id: this.renameModal.row.id,
        name: this.renameModal.name,
        style: style,
      }
      this.updateNavItem(params).then(res => {
        if (res.code === 0) {
          this.onGetGoodsDetail()
          this.renameModal.show = false
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },

    changeStatus (row, index) {
      const operator = row.status === 1 ? '停用' : '发布'
      var page = row.name
      this.$Modal
        .confirm({
          title: '提示',
          content: '确定要' + operator + '页面 ' + page + ' 吗?',
          onOk: () => {
            let list = this.getBarData
            let params = {
              id: list[index].id,
              isEnable: list[index].status === 1 ? 0 : 1
            }
            this.updateNavItem(params).then(res => {
              if (res.code === 0) {
                this.onGetGoodsDetail()
              }
              if (res.msg) {
                this.$Message.info(res.msg)
              }
            })


          },
          onCancel: () => {
          }
        })
    },
    //设置默认页
    setDefaultPage (row, index) {
      if (row.type === 10) {
        return
      }
      this.setNavHome(row.id).then(res => {
        if (res.code === 0) {
          this.onGetGoodsDetail()
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },

    onStyleSettingClick (row) {
      if ( row.isRelation){
        this.$Message.info("关联页面已设置,请去关联页面设置")
        return
      }
      if (row.type !== 5 && row.type !== 10) {
        if (row.page) {
          let pageName = row.page.title || ''
          let style = row.page.style ? JSON.parse(row.page.style) : null
          let customColor = style ? style.pageBgColor || '#F8F8F9' : '#F8F8F9'
          let textColor = style ? style.navTitleColor || '#333333' : '#333333'
          let titleBgColor = style ? style.navBgColor || 'white' : 'white'
          let logoWidth = style ? style.logoWidth || 0 : 0
          let logoHeight = style ? style.logoHeight || 0 : 0

          let bgPicWidth = style ? style.pageBgImgWidth || 0 : 0
          let bgPicHeight = style ? style.pageBgImgHeight || 0 : 0
          let extension = row.page.extension ? JSON.parse(row.page.extension) : null
          let showTitle = extension ? extension.showNav || 0 : 0
          let buttonUrl = extension ? extension.buttonUrl || '' : ''

          let logo = extension ? extension.logo || '' : ''
          let bgPic = extension ? extension.pageBgImg || '' : ''
          this.editStyleData = {
            editPageId: row.pageId || 0,
            pageName: pageName || '',
            customColor: customColor || '#F8F8F9',
            textColor: textColor || '#333333',
            titleBgColor: titleBgColor || 'white',
            logoWidth: logoWidth || 0,
            logoHeight: logoHeight || 0,
            bgPicWidth: bgPicWidth || 0,
            bgPicHeight: bgPicHeight || 0,

            showTitle: showTitle || 0,
            logo: logo || '',
            bgPic: bgPic || '',
            buttonUrl: buttonUrl || '',
            extension: {
              ...this.getEmptyPageExtension(),
              ...extension
            }
          }
        }
        this.showStyleSet = true
      }
    },
    onModalClose (status) {
      if (!status) {
        this.editShareData = {
          editPageId: 0,
          shareCover: '',
          shareTitle: '',
          showShareBtn: 0,
          extension: this.getEmptyPageExtension(),
        }
        this.editStyleData = {
          editPageId: 0,
          pageName: '',
          customColor: '#F8F8F9',
          textColor: '#333333',
          titleBgColor: 'white',
          logoWidth: 0,
          logoHeight: 0,
          bgPicWidth: 0,
          bgPicHeight: 0,

          showTitle: 0,
          logo: '',
          bgPic: '',
          buttonUrl: '',
          extension: this.getEmptyPageExtension(),
        }
      }
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    onIconOKClick () {
      this.onGetGoodsDetail()
      this.showPicChoose = false
    },
    onPicChooseClick (row) {
      this.selectData = row
      this.editPicData = JSON.parse(JSON.stringify(row))
      this.showPicChoose = true
    },
    getUpItemColor (index) {
      if (index === 0) {
        return '#BBBBBB'
      } else {
        return '#3B80FF'
      }
    },
    getDownItemColor (index) {
      if ((this.getBarData.length - 2) === index) {
        return '#BBBBBB'
      } else {
        return '#3B80FF'
      }
    },
    //上移
    moveUp (row, index) {
      if (index === 0) {
        return
      }

      let sort = this.getBarData[index - 1].sort
      let params = {
        id: row.id,
        sort
      }
      this.setNavSort(params).then(res => {
        if (res.code === 0) {
          this.onGetGoodsDetail()
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })

    },

    //下移
    moveDown (row, index) {
      if (index >= this.getBarData.length - 2) {
        return
      }
      let sort = this.getBarData[index + 1].sort
      let params = {
        id: row.id,
        sort
      }
      this.setNavSort(params).then(res => {
        if (res.code === 0) {
          this.onGetGoodsDetail()
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }

      })
    },
    onQrcodeDownload () {
      if (this.proQrcode) {
        handleSimpleDownload(this.proQrcode)
      }
    },
    onGetGoodsDetail () {
      this.getGoodDetail(this.proId).then(res => {
        if (res.code === 0) {
          let imgUrl = ''
          let data = res.data
          if (data.coverList && data.coverList.length > 0) {
            for (let i = 0; i < data.coverList.length; i++) {
              let coverListItem = data.coverList[i]
              if (coverListItem && coverListItem.imgUrl) {    //图片类型
                imgUrl = coverListItem.imgUrl
                break
              } else if (coverListItem && coverListItem.videoUrl && coverListItem.videoUrl.endsWith('.mp4')) {//视频类型
                imgUrl = coverListItem.videoUrl + '?x-oss-process=video/snapshot,t_1000,f_png,w_0,h_0'
                break
              }
            }
          }
          this.proImgUrl = imgUrl
          this.proQrcode = data.qrcodeUrl
          this.proName = data.name
          this.buttombarData = data.navigate.buttonList || []
        }
      })
    },
    onRelationEdit (row) {
      if (row.type === 10) {
        return
      }
      this.click2ShowRelationEdit = row
      this.relationEditInfo = {
        hasdecorateMode: row.isRelation ? 1 : 0,
        url: row.relationLink ? row.relationLink.link : '' || ''
      }
      this.showRelation = true
    },
    onRelationSetOK (config) {
      let params = {
        id: this.click2ShowRelationEdit.id,
        isRelation: config.url ? 1 : 0,
        relationLink: config.url
      }
      this.updateNavItem(params).then(res => {
        if (res.code === 0) {
          this.onGetGoodsDetail()
          this.showRelation = false
        }
      })
    },
    onRelationModalClose (status) {
      //   if (!status) {
      //     this.relationEditInfo = {
      //       hasdecorateMode: 1,
      //       url: ''
      //     }
      //   }
    },
    getEmptyPageExtension () { //空extension
      return {
        showShareBtn: 1,
        showNav: 0,
        logo: '',
        pageBgImg: '',
        buttonUrl: ''
      }
    },
    ...mapActions([
      'updateNavItem',
      'setNavHome',
      'setNavSort',
      'getGoodDetail'
    ])
  },
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {


  //.ivu-modal {
  //  display: flex;
  //  align-items: center;
  //  justify-content: center;
  //  top: 200px;
  //}

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}


.modal-setting2 ::v-deep {
  .ivu-modal-header {
    display: none;
  }
}


</style>
<style scoped>
.modals >>> .ivu-modal-body {
  padding: 0;
}

.tablePtye >>> .ivu-table-cell {
  padding-left: 5px;
  padding-right: 5px;
}

/*.modals >>> .ivu-modal-content {*/
/*border-bottom-left-radius: 0px;*/
/*border-bottom-right-radius: 0px;*/
/*}*/
</style>
